$('.palvelupaketit .content-header').click( function() {
    if(! $(this).parent().hasClass('open')) {
        $(this).parent().addClass('open')
        $(this).parent().addClass('opening')
    } else {
        $(this).parent().removeClass('open')
        $(this).parent().addClass('closing')
    }

    $(this).siblings('.full-content').slideToggle( 400, 'swing', function() {
        $(this).parent().removeClass('opening')
        $(this).parent().removeClass('closing')
    })
})